import styled, { css } from 'styled-components'

export const StyledParametersList = styled.div`
    position: absolute;
    top: 26px;
    left: -135px;
    min-width: 260px;
    border-radius: 0;
    background: ${props => (props.dark ? '#303a4f' : 'var(--gray-0)')};

    margin-top: 2px;
    border: 1px solid ${props => (props.dark ? '#172033' : 'var(--gray-400)')};
    
    border-radius: 0;
    box-shadow: 0 0 5px 0 rgba(96,105,128,.25);
    z-index: 100;

    ${props =>
        props.pluginHeaderNavigationDetected &&
        css`
            top: 32px;
            left: -5px;
            z-index: 10000;
        `}

    ul {
        margin-top: 10px;
        margin-bottom: 5px;
        display: grid;
        grid-auto-flow: column;
        grid-template-rows: repeat(7, auto);

        li {
            display: block;
            padding: 4px 0px 4px 10px;
            margin-bottom: 5px;
            margin-right: 8px;
            min-width: 250px;

            ${props =>
                props.dark &&
                css`
                    label {
                        color: #fff;
                    }
                    input[type="text"] {
                        color: #fff;
                        background-color: #1b273e;
                        box-shadow: none;
                        border-color: #172033;
                    }
                `}
        }
    }
`
